import { css } from "@emotion/react"
import { Typography } from "matsuri-ui"
import { CompanyNotificationIcon } from "../Icon/CompanyNotificationIcon"
import { useCompanyNotification } from "@/hooks/useCompanyNotification"
import { useTranslation } from "@/hooks/useTranslation"

export const CompanyNotificationBanner = () => {
    const { t } = useTranslation()
    const { data: companyNotification } = useCompanyNotification()
    return (
        <>
            {companyNotification?.exists && (
                <div
                    css={css`
                        width: 100%;
                        padding: 16px;
                        background-color: white;
                    `}
                >
                    <div
                        css={css`
                            position: relative;
                        `}
                    >
                        <CompanyNotificationIcon size="32" />
                        <Typography
                            as="span"
                            variant="body"
                            css={css`
                                position: relative;
                                top: -8px;
                            `}
                        >
                            {t("管理者からのお知らせ")}
                        </Typography>
                    </div>
                    <div>
                        <Typography variant="caption">
                            {companyNotification.text}
                        </Typography>
                    </div>
                </div>
            )}
        </>
    )
}
